




































































import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { NoveltyRule } from '@/models/api/campaign/noveltyCampaign'
import { CampaignSummary } from '@/usecases/novelty/campaign-summary'
import { FkuConstraint } from '@/usecases/novelty/fku-constraint'
import { FkuSummary } from '@/usecases/novelty/fku-summary'
import { SkuSummary } from '@/usecases/novelty/sku-summary'
import { PluginMixin } from '@spa/mixins/plugin'
import EditableNoveltyItem from './EditableNoveltyItem.vue'
import ReadOnlyNoveltyItem from './ReadOnlyNoveltyItem.vue'
import { NoveltyEntity, Selection } from './selection'
import { convertToSingleUseCaseState, convertToUseCaseState } from './util'

@Component({
  components: {
    EditableNoveltyItem,
    ReadOnlyNoveltyItem,
  },
})
export default class NoveltyFkuSection extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ default: false })
  readOnly: boolean

  @Prop({ required: true })
  rule: NoveltyRule

  @Prop({ required: true })
  entities: NoveltyEntity[]

  @Prop({ required: true })
  noveltySummary: CampaignSummary

  get cartPrice(): number {
    return this.noveltySummary.basePriceToSelectNovelty
  }

  get displayedEntities(): NoveltyEntity[] {
    return this.readOnly ?
      this.entities.filter(entity => entity.state.count > 0) :
      this.entities
  }

  get summary(): FkuSummary {
    return new FkuSummary(
      this.rule,
      this.entities.map(entity => entity.item),
      convertToUseCaseState(this.entities),
      this.cartPrice
    )
  }

  get constraint(): FkuConstraint {
    return new FkuConstraint(this.summary)
  }

  get totalCountIsValid(): boolean {
    return this.constraint.fkuIsValid
  }

  get allSkuConstraintsValid(): boolean {
    return this.constraint.allSkuConstraintsAreValid
  }

  get noveltyName(): string {
    const entity = _.first(this.entities)

    return entity ?  entity.item.productName : ''
  }

  get totalCount(): number {
    return this.summary.totalCount
  }

  get userCanChangeCount(): boolean {
    return this.summary.userCanChangeCount
  }

  get shouldShow(): boolean {
    return this.displayedEntities.length > 0
  }

  makeSummary(rule: NoveltyRule, entity: NoveltyEntity, cartPrice: number): SkuSummary {
    return new SkuSummary(rule, entity.item, convertToSingleUseCaseState(entity), cartPrice)
  }

  handleSelect(val: Selection) {
    this.emitSelect(val)
  }

  @Emit('select')
  emitSelect(_val: Selection) {
    // Do nothing
  }
}
